function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopyIcon = function SvgCopyIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M10.694 0l.055.005c.143.026.251.15.251.3v3.667L10.997 4h3.697c.17 0 .306.137.306.306v10.388a.306.306 0 0 1-.306.306H4.306A.306.306 0 0 1 4 14.694v-3.698L3.972 11H.306l-.055-.005a.306.306 0 0 1-.251-.3V.304L.005.252A.306.306 0 0 1 .305 0h10.39zm3.695 4.611H4.613v9.778h9.777V4.61zm-4-4H.61v9.778h3.361L4 10.39V4.306c0-.17.137-.306.306-.306h6.085l-.002-.028V.612z"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy_icon.86212181.svg";
export { ForwardRef as ReactComponent };